import { Link } from 'react-router-dom';
import SEO from '@/components/ui/SEO';

const NotFoundPage: React.FC = () => {
  return (
    <>
      <SEO title="Page Not Found" />

      <div className="min-h-[600px] flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-9xl font-bold text-primary mb-4">404</h1>
          <h2 className="text-3xl font-bold mb-4">Page Not Found</h2>
          <p className="text-xl text-gray-600 mb-8">
            The page you're looking for doesn't exist or has been moved.
          </p>
          <Link to="/" className="btn btn-primary btn-lg">
            Go Back Home
          </Link>
        </div>
      </div>
    </>
  );
};

export default NotFoundPage;
